import { Guid, Nillable } from '@web/utils';

export class PublicCartAddItem {
  public constructor(
    private readonly data: {
      id: Guid;
      quantity: number;
      subProductId?: Nillable<Guid>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get subProductId(): Nillable<Guid> {
    return this.data.subProductId;
  }
}
